module.exports = __webpack_public_path__ + "static/media/search-results.90db23e1.jpg";